import { render, staticRenderFns } from "./Fondeadores.vue?vue&type=template&id=59504aba&scoped=true"
import script from "./Fondeadores.vue?vue&type=script&lang=js"
export * from "./Fondeadores.vue?vue&type=script&lang=js"
import style0 from "./Fondeadores.vue?vue&type=style&index=0&id=59504aba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59504aba",
  null
  
)

export default component.exports